'use strict';

window.BASE_URL = 'https://api.thenexvolt.com/api/v2';
window.BASE_URL_GOLANG = 'https://api.thenexvolt.com/storefront/api/v2';
// window.BASE_URL = 'http://192.168.1.146:3001/api/v2';

class FacebookPixel {
  init(pixels) {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    pixels.forEach((item) => {
      fbq('init', item.id);
    });
    fbq('track', 'PageView');
  }
  send(event, data, eventID = '') {
    if (window?.fbq) {
      window.fbq('track', event, data, { eventID });
      console.log(`Facebook Pixel Event "${event}" triggered with data:`, {
        data,
        eventID,
      });
    } else console.error('Facebook Pixel is not initialized');
  }
  viewContent(_product) {
    const data = {
      content_name: _product?.title || '',
      content_brand: _product?.vendor || '',
      shop_name: window.Shopify.shop,
      content_ids: [_product.id || _product.handle],
      content_type: 'product',
      value: _product?.price / 100,
      currency: window.Shopify.currency.active,
    };
    this.send('ViewContent', data);
  }
  addToCart(_product) {
    const data = {
      content_ids: [_product.id],
      content_name: _product.title,
      content_type: 'product',
      value: _product?.price / 100,
      currency: window.Shopify.currency.active,
      quantity: _product.quantity,
    };
    this.send('AddToCart', data);
  }
  initCheckout(cart) {
    this.send(
      'InitiateCheckout',
      {
        content_type: 'product',
        shop_name: shopName,
        content_ids: cart?.items?.map((item) => item.variantId || item.productId).join(','),
        content_brand: cart?.items?.map((item) => item.vendor).join(','),
        contents: cart?.items?.map((item) => ({
          id: item.variantId || item.productId,
          quantity: item.quantity,
          item_price: item.price,
        })),
        currency: cart.currency,
        num_items: cart.totalItems,
        value: cart.totalPrice,
      },
      cart._id
    );
  }
}
class GoogleAds {
  analyticIds = [];
  conversions = [];

  init(analyticIds = [], conversions = []) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.id = 'x-gtag';
      script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticIds[0] || conversions[0]}`;
      script.onload = () => resolve();
      script.onerror = (err) => reject(err);
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag =
        window.gtag ||
        function () {
          window.dataLayer.push(arguments);
        };

      window.gtag('js', new Date());
      analyticIds?.forEach((item) => {
        window.gtag('config', item);
      });

      this.analyticIds = analyticIds || [];
      this.conversions = conversions || [];

      this.conversions?.forEach((item) => {
        window.gtag('config', item, { allow_enhanced_conversions: true });
      });
    });
  }

  send(name, data) {
    if (typeof window !== 'undefined' && window?.gtag) {
      window.gtag('event', name, data);
      console.log(`Google Analytic Action "${name}" triggered with data:`, data);
    } else {
      console.warn('Google Analytic Action is not initialized or running on the server-side.');
    }
  }

  viewContent(_product) {
    this.send('page_view', {
      page_path: window.location.pathname,
      send_to: this.analyticIds.join(','),
    });
    this.send('view_item', {
      items: [
        {
          google_business_vertical: 'retail',
          id: _product.id,
        },
      ],
      value: _product / 100,
      send_to: this.analyticIds.join(','),
    });
    this.send('view_item', {
      currency: window.Shopify.currency.active,
      eventName: 'view_item',
      shop_id: window.shop.id,
      shop_name: window.shop.name,
      items: [
        {
          id: _product.id || _product.handle,
          name: _product.title,
          price: _product.price / 100,
          brand: _product?.vendor || '',
          category: '',
          item_id: _product.id || _product.handle,
          item_name: _product.title,
          item_brand: _product?.vendor || '',
          item_category: '',
        },
      ],
    });
  }

  addToCart(_product) {
    this.send('add_to_cart', {
      currency: window.Shopify.currency.active,
      eventName: 'add_to_cart',
      shop_id: window.shop.id,
      shop_name: window.shop.name,
      send_to: this.analyticIds.join(','),
      value: _product / 100,
      items: [
        {
          id: _product.id || _product.handle,
          name: _product.title,
          price: _product.price / 100,
          brand: _product?.vendor || '',
          category: '',
          item_id: _product.id || _product.handle,
          item_name: _product.title,
          item_brand: _product?.vendor || '',
          item_category: '',
          quantity: _product.quantity,
        },
      ],
    });
    this.send('add_to_cart', {
      items: [
        {
          google_business_vertical: 'retail',
          id: _product.id,
        },
      ],
      value: _product / 100,
      send_to: this.analyticIds.join(','),
    });
  }

  initCheckout(cart) {
    this.send('begin_checkout', {
      currency: window.Shopify.currency.active,
      value: cart.totalPrice,
      send_to: this.analyticIds.join(','),
      items: cart.items.map((item) => ({
        google_business_vertical: 'retail',
        id: item.variantId || item.productId,
      })),
    });
    this.send('begin_checkout', {
      currency: window.Shopify.currency.active,
      eventName: 'begin_checkout',
      shop_id: window.shop.id,
      shop_name: window.shop.name,
      send_to: this.analyticIds.join(','),
      value: cart.totalPrice,
      items: cart.items.map((item) => ({
        id: item.variantId || item.productId,
        name: item.title,
        price: item.unitPrice,
        brand: '',
        category: '',
        quantity: item.quantity,
        item_id: item.variantId || item.productId,
        item_name: item.title,
        item_brand: '',
        item_category: '',
        item_variant: item.variantId || item.productId,
      })),
    });
  }
}
class TiktokPixel {
  constructor() {}
  init(pixels) {
    !(function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      ((ttq.methods = [
        'page',
        'track',
        'identify',
        'instances',
        'debug',
        'on',
        'off',
        'once',
        'ready',
        'alias',
        'group',
        'enableCookie',
        'disableCookie',
        'holdConsent',
        'revokeConsent',
        'grantConsent',
      ]),
        (ttq.setAndDefer = function (t, e) {
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }));
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ((ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
          ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      }),
        (ttq.load = function (e, n) {
          var i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
          ((ttq._i = ttq._i || {}),
            (ttq._i[e] = []),
            (ttq._i[e]._u = i),
            (ttq._t = ttq._t || {}),
            (ttq._t[e] = +new Date()),
            (ttq._o = ttq._o || {}),
            (ttq._o[e] = n || {}));
          var o = document.createElement('script');
          ((o.type = 'text/javascript'), (o.async = !0), (o.src = i + '?sdkid=' + e + '&lib=' + t));
          var a = document.getElementsByTagName('script')[0];
          a.parentNode.insertBefore(o, a);
        }));
      pixels.forEach((item) => {
        ttq.load(item.id);
      });
      ttq.page();
    })(window, document, 'ttq');
  }
  send(name, data, id) {
    if (typeof window !== 'undefined' && window.ttq) {
      window.ttq.track(name, data, {
        event_id: id,
      });
      console.log(`Tiktok Action "${name}" triggered with data:`, {
        data,
        event_id: id,
      });
    } else {
      console.warn('Tiktok Action is not initialized or running on the server-side.');
    }
  }
  viewContent(_product) {
    this.send('ViewContent', {
      contents: [
        {
          content_id: _product.id || _product.handle,
          content_type: 'product',
          content_name: _product?.title || '',
        },
      ],
      value: String(_product?.price / 100),
      currency: window.Shopify.currency.active,
    });
  }
  addToCart(_product) {
    this.send('AddToCart', {
      contents: [
        {
          content_id: _product.id || _product.handle,
          content_type: 'product',
          content_name: _product?.title || '',
        },
      ],
      quantity: _product?.quantity || 1,
      value: String(_product?.price / 100),
      currency: window.Shopify.currency.active,
    });
  }
  initCheckout(cart) {
    this.send(
      'PlaceAnOrder',
      {
        currency: cart.currency,
        content_type: 'product',
        contents: cart?.items?.map((item) => ({
          id: item.variantId || item.productId,
          quantity: item.quantity,
          item_price: item.unitPrice,
          content_id: item.variantId || item.productId,
          content_name: item.variantTitle,
          content_type: 'product',
        })),
        value: cart.totalPrice,
      },
      cart._id
    );
  }
}
class Pinterest {
  constructor() {}
  init(tags) {
    !(function (e) {
      if (!window.pintrk) {
        window.pintrk = function () {
          window.pintrk.queue.push(Array.prototype.slice.call(arguments));
        };
        var n = window.pintrk;
        ((n.queue = []), (n.version = '3.0'));
        var t = document.createElement('script');
        ((t.async = !0), (t.src = e));
        var r = document.getElementsByTagName('script')[0];
        r.parentNode.insertBefore(t, r);
      }
    })('https://s.pinimg.com/ct/core.js');
    tags.forEach((item) => {
      pintrk('load', item.id, { em: item.email });
    });
    pintrk('page');
  }
  send(name, data) {
    if (typeof window !== 'undefined' && window.pintrk) {
      window.pintrk('track', name, data);
      console.log(`Pinterest Tag "${name}" triggered`, data);
    } else {
      console.warn('Pinterest Tag not initialized or running server-side.');
    }
  }
  viewContent(_product) {
    this.send('pagevisit', {
      value: _product?.price / 100,
      currency: window.Shopify.currency.active,
      line_items: [
        {
          product_id: _product?.id || _product?.handle,
          product_name: _product.title,
          product_price: _product?.price / 100,
          product_quantity: 1,
        },
      ],
    });
  }
  addToCart(_product) {
    this.send('addtocart', {
      event_id: _product?.id || _product?.handle,
      value: _product?.price / 100,
      currency: window.Shopify.currency.active,
      order_quantity: _product.quantity || 1,
      line_items: [
        {
          product_id: _product?.id || _product?.handle,
          product_name: _product.title,
          product_price: _product?.price / 100,
          product_quantity: _product.quantity || 1,
        },
      ],
    });
  }
  initCheckout(cart) {
    this.send('checkout', {
      value: cart?.totalPrice,
      currency: cart.currency,
      order_quantity: cart.totalItems,
      item_count: cart.totalItems,
      event_id: cart?._id,
      line_items: cart.items.map((item) => ({
        product_name: item.variantTitle,
        product_id: item.variantId || item.productId,
        product_price: item.unitPrice,
        product_quantity: item.quantity,
      })),
    });
  }
}
class SnapChatPixel {
  constructor() {}
  init(pixels) {
    (function (e, t, n) {
      if (e.snaptr) return;
      var a = (e.snaptr = function () {
        a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments);
      });
      a.queue = [];
      var s = 'script';
      r = t.createElement(s);
      r.async = !0;
      r.src = n;
      var u = t.getElementsByTagName(s)[0];
      u.parentNode.insertBefore(r, u);
    })(window, document, 'https://sc-static.net/scevent.min.js');
    pixels.forEach((item) => {
      snaptr('init', item.id, { user_email: item.email });
    });
    snaptr('track', 'PAGE_VIEW');
  }
  send(name, data, eventID = '') {
    if (typeof window !== 'undefined' && window.snaptr) {
      window.snaptr('track', name, data, { eventID });
      console.log(`Snap Pixel "${name}" triggered`, { data });
    } else {
      console.warn('Snap Pixel not initialized or running server-side.');
    }
  }
  viewContent(_product) {
    this.send(
      'VIEW_CONTENT',
      {
        item_ids: [_product?.id || _product?.handle],
        price: _product?.price / 100,
        currency: window.Shopify.currency.active,
        item_name: _product?.title,
        item_brand: _product?.vendor || '',
        item_type: 'product',
      },
      window.__sessionId
    );
  }
  addToCart(_product) {
    this.send(
      'ADD_CART',
      {
        item_ids: [_product?.id || _product?.handle],
        price: _product?.price / 100,
        currency: window.Shopify.currency.active,
        item_name: _product?.title || '',
        number_items: _product.quantity || 1,
      },
      _product?.id || _product?.handle
    );
  }
  initCheckout(cart) {
    this.send(
      'START_CHECKOUT',
      {
        item_ids: cart.items.map((item) => item.variantId || item.productId),
        price: cart?.totalPrice,
        currency: cart.currency,
        number_items: cart?.totalItems,
        item_type: 'product',
        items: cart?.items?.map((item) => ({
          id: item.variantId || item.productId,
          quantity: item.quantity,
          item_price: item.price / 100,
        })),
      },
      cart._id
    );
  }
}
class NewsbreakPixel {
  constructor() {}
  init(pixels) {
    (!(function (e, n, t, s, c, i, a) {
      e[s] ||
        (((c = e[s] =
          function () {
            c.process ? c.process.apply(c, arguments) : c.queue.push(arguments);
          }).queue = []),
        (c.t = +new Date()),
        ((i = n.createElement(t)).async = 1),
        (i.src =
          'https://static.newsbreak.com/business/tracking/nbpixel.js?t=' +
          864e5 * Math.ceil(new Date() / 864e5)),
        (a = n.getElementsByTagName(t)[0]).parentNode.insertBefore(i, a));
    })(window, document, 'script', 'nbpix'),
      pixels.forEach((item) => {
        nbpix('init', `ID-${item}`);
      }));
    nbpix('event', 'pageload');
  }
  send(name, data) {
    if (typeof window !== 'undefined' && window?.nbpix) {
      window.nbpix('event', name, data);
      console.log(`Newsbreak Action "${name}" triggered with data:`, data);
    } else {
      console.warn('Newsbreak Action is not initialized or running on the server-side.');
    }
  }
  viewContent(_product) {
    this.send('view_content', {
      item_id: _product.id || _product.handle,
      item_name: _product.title || '',
      nb_value: _product?.price / 100,
      currency: window.Shopify.currency.active,
      page_url: window.location.href,
    });
  }
  addToCart(_product) {
    this.send('add_to_cart', {
      item_id: _product.id || _product.handle,
      item_name: _product.title,
      nb_value: _product?.price / 100,
      currency: window.Shopify.currency.active,
      quantity: _product?.quantity,
      cart_id: _product.id || _product.handle,
    });
  }
  initCheckout(cart) {
    this.send('initiate_checkout', {
      currency: cart.currency,
      nb_value: cart.totalPrice,
      num_items: cart.totalItems,
      items: cart.items.map((item) => ({
        content_id: item.variantId || item.productId,
        content_name: item.variantTitle,
        price: item.price / 100,
        quantity: item.quantity,
      })),
      cart_id: cart._id,
    });
  }
}
class Checkout {
  constructor() {
    this.overlay = document.getElementById('checkout-overlay');
  }
  showOverlay() {
    this.overlay.style.display = 'flex';
  }
  hideOverlay() {
    this.overlay.style.display = 'none';
  }
  async getProxies() {
    try {
      const response = await fetch(`${window.BASE_URL}/proxies`);
      if (!response.ok) throw new Error('Get proxies error!');
      const { data } = await response.json();
      this.proxies = data?.proxies || [];
      this.proxyGroupId = data?.proxyGroupId || '';
      const paypalProxy = this.proxies.find((item) => item.proxyType === 'PAYPAL');
      if (!paypalProxy) {
        document.getElementById('paypal-product').remove();
      }
    } catch (error) {
      console.log('error: ', error);
    }
  }
  async getCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Get cart error!');
    return response.json();
  }
  async postAction(cart, url) {
    try {
      await fetch('', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          shop: window.Shopify.shop,
          visitorId: window.__visitorId,
          sessionId: window.__sessionId,
          eventType: 'checkout',
          checkoutId: cart._id,
          cartId: cart._id,
          url,
        }),
      });
      window.adsTracking.facebook.initCheckout(cart);
      window.adsTracking.google.initCheckout(cart);
      window.adsTracking.tiktok.initCheckout(cart);
      window.adsTracking.pinterest.initCheckout(cart);
      window.adsTracking.snapchat.initCheckout(cart);
      window.adsTracking.newsbreak.initCheckout(cart);
    } catch (error) {
      console.log('error: ', error);
    }
  }
  async buyNow() {
    try {
      this.showOverlay();
      const cart = await this.getCart();
      const dataPost = {
        shop: window.Shopify.shop,
        cartId: cart.token,
        store: {
          ...window.shop,
          trackingData: getTrackingData(),
        },
      };
      const response = await fetch(`${window.BASE_URL}/carts`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataPost),
      });
      if (!response.ok) throw new Error(response.statusText);
      const { data, success } = await response.json();
      if (success) {
        const checkoutId = data._id;
        const url = `/a/ck/checkout/${checkoutId}`;
        this.postAction(data.data, url);
        setTimeout(() => {
          window.location.href = url;
        }, 2000);
      }
    } catch (error) {
      console.log('error: ', error);
    } finally {
      this.hideOverlay();
    }
  }
}
class Visitor {
  getCookie(name) {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2] : null;
  }

  setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value};expires=${expires};path=/;SameSite=Lax;Secure`;
  }

  getSessionFromStorage() {
    try {
      return localStorage.getItem('_sess_pub');
    } catch (error) {
      console.error('Error getting session from localStorage:', error);
      return null;
    }
  }

  setSessionToStorage(sessionId) {
    try {
      localStorage.setItem('_sess_pub', sessionId);
    } catch (error) {
      console.error('Error setting session to localStorage:', error);
    }
  }

  generateUUID() {
    return (
      crypto.randomUUID?.() ||
      'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      })
    );
  }

  applyIdentity(visitorId, sessionId) {
    window.__visitorId = visitorId; // Persist ~1 year
    window.__sessionId = sessionId; // Infinite persistence
  }

  async getVisitor() {
    try {
      let visitorId = this.getCookie('_anon_pub');
      let sessionId = this.getSessionFromStorage() || `sess_${this.generateUUID()}`;

      if (!this.getSessionFromStorage()) {
        this.setSessionToStorage(sessionId);
      }

      if (!visitorId) {
        visitorId = this.generateUUID();
        this.setCookie('_anon_pub', visitorId, 365);
      }

      this.applyIdentity(visitorId, sessionId);
      return { visitorId, sessionId };
    } catch (error) {
      console.error('Error in getVisitor:', error);
      const visitorId = this.generateUUID();
      const sessionId = this.getSessionFromStorage() || `sess_${this.generateUUID()}`;
      this.setCookie('_anon_pub', visitorId, 365);
      this.setSessionToStorage(sessionId);
      this.applyIdentity(visitorId, sessionId);
      return { visitorId, sessionId };
    }
  }

  constructor() {
    this.getVisitor();
  }
}

async function postAction() {
  try {
    const dataPost = {
      shop: window.Shopify.shop,
      eventType: 'view',
      visitorId: window.__visitorId,
      sessionId: window.__sessionId,
      url: window.location.href,
      storeType: 'SHOPIFY',
    };
    await fetch(`${window.BASE_URL}/analytics/event`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataPost),
    });
  } catch (error) {
    console.log('error: ', error);
  }
}
async function postActionProductPage() {
  try {
    const dataPost = {
      shop: window.Shopify.shop,
      eventType: 'product_view',
      visitorId: window.__visitorId,
      sessionId: window.__sessionId,
      url: window.location.href,
      productId: String(product?.id),
      variantId: String(product?.variants[0]?.id),
      storeType: 'SHOPIFY',
    };
    await fetch(`${window.BASE_URL}/analytics/event`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataPost),
    });
    window.adsTracking.facebook.viewContent(product);
    window.adsTracking.google.viewContent(product);
    window.adsTracking.tiktok.viewContent(product);
    window.adsTracking.pinterest.viewContent(product);
    window.adsTracking.snapchat.viewContent(product);
    window.adsTracking.newsbreak.viewContent(product);
  } catch (error) {
    console.log('error: ', error);
  }
}

async function getAdsTracking() {
  try {
    const params = new URLSearchParams();
    params.append('shop', window.Shopify.shop);
    params.append('storeType', 'SHOPIFY');
    if (window.meta.page.pageType === 'product') {
      params.append('productId', window.meta.product.id);
    }
    const response = await fetch(`${window.BASE_URL_GOLANG}/stores/pixels?${params.toString()}`);
    if (!response.ok) throw new Error(response.statusText);
    const data = await response.json();
    const facebookPixels = data?.data?.facebookPixels || [];
    const googleAds = data?.data?.googleAds || [];
    const googleAnalytics = data?.data?.googleAnalytics || [];
    const newsbreakPixels = data?.data?.newsbreakPixels || [];
    const pinterestTags = data?.data?.pinterestTags || [];
    const snapchatPixels = data?.data?.snapchatPixels || [];
    const tiktokPixels = data?.data?.tiktokPixels || [];

    if (facebookPixels.length) {
      window.adsTracking.facebook.init(facebookPixels);
    }
    if (googleAds.length || googleAnalytics.length) {
      await window.adsTracking.google.init(googleAnalytics, googleAds);
    }
    if (newsbreakPixels.length) {
      window.adsTracking.newsbreak.init(newsbreakPixels);
    }
    if (pinterestTags.length) {
      window.adsTracking.pinterest.init(pinterestTags);
    }
    if (snapchatPixels.length) {
      window.adsTracking.snapchat.init(snapchatPixels);
    }
    if (tiktokPixels.length) {
      window.adsTracking.tiktok.init(tiktokPixels);
    }
  } catch (error) {
    console.log('error: ', error);
  }
}

function getRefQueryParam(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(location.search);
  return results === null || results[1] === undefined
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function saveTrackingData() {
  if (!localStorage.getItem('track_first')) {
    localStorage.setItem('track_ref', document.referrer || 'none');
    localStorage.setItem('track_first', window.location.href);
    const utm_source = getRefQueryParam('utm_source');
    const utm_medium = getRefQueryParam('utm_medium');
    const utm_content = getRefQueryParam('utm_content');
    const utm_campaign = getRefQueryParam('utm_campaign');
    const utm_term = getRefQueryParam('utm_term');
    const utm_id = getRefQueryParam('utm_id');
    if (utm_source) localStorage.setItem('utm_source', utm_source);
    if (utm_medium) localStorage.setItem('utm_medium', utm_medium);
    if (utm_campaign) localStorage.setItem('utm_campaign', utm_campaign);
    if (utm_content) localStorage.setItem('utm_content', utm_content);
    if (utm_term) localStorage.setItem('utm_term', utm_term);
    if (utm_id) localStorage.setItem('utm_id', utm_id);
  }
}
function extractTrafficSourceFromReferer(referer) {
  const TRAFFIC_SOURCES = [
    'facebook.com',
    'direct',
    'tiktok.com',
    'yandex',
    'trustpilot',
    'mail.google.com',
    'google.com',
    'apps.admob.com',
    't.co',
    'base.vn',
    'mail.yahoo.com',
    'yahoo.com',
    'youtube.com',
    'messenger.com',
    'instagram.com',
    'lavasoft.gosearchresults.com',
    'klaviyo.com',
    'ecosia.org',
    'duckduckgo',
    'bing.com',
    'baidu.com',
  ];
  for (const source of TRAFFIC_SOURCES) {
    if (referer.includes(source)) {
      return source;
    }
  }
  return 'direct';
}
function getTrackingData() {
  const data = {
    utmParams: {
      source: '',
      medium: '',
      campainId: '', // Lưu ý: Có thể là typo của "campaignId"
      utm_content: '',
      utm_term: '',
      utm_id: '',
    },
    conversion: {
      firstPage: '',
      refererSite: '',
      source: '',
    },
    adbCheckout: {
      reference_method: 'normal',
      abdCartId: '', // Lưu ý: Có thể là typo của "adbCartId"
    },
  };
  // 1. Chỉ đọc các thông tin tracking khi track_ref tồn tại
  const trackRef = localStorage.getItem('track_ref');
  if (trackRef) {
    data.conversion = {
      firstPage: localStorage.getItem('track_first') || '',
      refererSite: trackRef,
      source: extractTrafficSourceFromReferer(trackRef),
    };
  }
  // 2. Chỉ đọc các tham số UTM khác khi utm_source tồn tại
  const utmSource = localStorage.getItem('utm_source');
  if (utmSource) {
    data.utmParams = {
      source: utmSource,
      medium: localStorage.getItem('utm_medium') || '',
      campainId: localStorage.getItem('utm_campaign') || '',
      utm_content: localStorage.getItem('utm_content') || '',
      utm_term: localStorage.getItem('utm_term') || '',
      utm_id: localStorage.getItem('utm_id') || '',
    };
  }
  return data;
}

window.adsTracking = {
  facebook: new FacebookPixel(),
  google: new GoogleAds(),
  tiktok: new TiktokPixel(),
  pinterest: new Pinterest(),
  snapchat: new SnapChatPixel(),
  newsbreak: new NewsbreakPixel(),
};
window.checkout = new Checkout();
window.visitor = new Visitor();
(async function () {
  await getAdsTracking();
  await postAction();
  if (window.meta.page.pageType === 'product') {
    await postActionProductPage();
  }
  saveTrackingData();
})();
